import {
  UPDATE_OPTION,
  UPDATE_COLOR,
  SELECT_PRINT_OPTION,
  UPDATE_DESIGN_NAME,
  DESIGN,
  PRODUCTVARIANTCOLORS,
  PRODUCTVARIANT,
  SAVE_DESIGN,
  ADD_DESIGN_TO_CART,
  DISPLAY_LOGIN_PROMPT,
  OVERRIDES_APPLIED,
} from "../actions";
import calculatePreviewScale from "../services/utils/calculatePreviewScale";
import { SET_ORIGINAL_DESIGN_ID } from "../actions/index";

const initialState = {
  colors: [],
  layer_set: [],
  isSaving: false,
  isRedirecting: false,
  displayLoginPrompt: false,
};

function findMatchingColor(categories, originalColor) {
  if (!originalColor) {
    return null;
  }
  for (let i = 0; i < categories.length; i++) {
    let category = categories[i];
    if (category.id === originalColor.category_id) {
      for (let j = 0; j < category.colors.length; j++)
        if (category.colors[j].name === originalColor.name) {
          return { ...category.colors[j] };
        }
    }
  }
  return null;
}

function ensureLayerHasDefaultColor(new_layer, old_layer) {
  let layer = { ...new_layer };
  let wasMatched = false;
  if (layer.has_color) {
    if (old_layer) {
      //see if we can use the same color
      let toMatch = layer.color
        ? layer.color
        : old_layer.color
          ? old_layer.color
          : null;
      let matchingColor = findMatchingColor(new_layer.colors, toMatch);
      if (matchingColor) {
        wasMatched = true;
        layer.color = { ...matchingColor };
      }
    }

    if (typeof layer.color === "undefined" || !wasMatched) {
      // we don't have a color set, so choose the first color
      let colors = Object.values(new_layer.colors);
      if (colors.length) {
        layer.color = { ...colors[0].colors[0] }; //TODO find a better way to do this
      }
    }
  }

  wasMatched = false;
  if (layer.has_print_color) {
    if (old_layer) {
      let toMatch = layer.print_color
        ? layer.print_color
        : old_layer.print_color
          ? old_layer.print_color
          : null;
      let matchingColor = findMatchingColor(new_layer.print_colors, toMatch);
      if (matchingColor) {
        wasMatched = true;
        layer.print_color = { ...matchingColor };
      }
    }

    if (typeof layer.print_color === "undefined" || !wasMatched) {
      //TODO change this so that it doesn't only rely on the PV's print_colors. needs to rely on PV print color cats. and more
      let print_colors = Object.values(new_layer.print_colors);
      if (print_colors.length) {
        layer.print_color = { ...print_colors[0].colors[0] }; //TODO find a better way to do this
      }
    }
  }
  return layer;
}

function mergeLayers(oldLayer, newLayer) {
  /** we don't want to use newLayer's id here. In the case that we're overwriting an design, we'll want to update the existing paragraph */
  let layer = {
    ...oldLayer,
    allow_alignment_edits: newLayer.allow_alignment_edits,
    allow_color_edits: newLayer.allow_color_edits,
    allow_image: newLayer.allow_image,
    allow_image_position_edits: newLayer.allow_image_position_edits,
    allow_text: newLayer.allow_text,
    allow_text_position_edits: newLayer.allow_text_position_edits,
    character_type: newLayer.character_type,
    //color: newLayer.color,
    colors: newLayer.colors || [],
    color_from_layer: newLayer.color_from_layer,
    color_setting_name: newLayer.color_setting_name,
    color_setting_type: newLayer.color_setting_type,
    default_rotation: newLayer.default_rotation,
    has_color: newLayer.has_color,
    has_print_color: newLayer.has_print_color,
    height: newLayer.height,
    image_collection_name: newLayer.image_collection_name,
    image_collection_max_length: newLayer.image_collection_max_length,
    layer_id: newLayer.layer_id,

    is_applique: newLayer.is_applique,
    is_cutout: newLayer.is_cutout,
    is_debossed: newLayer.is_debossed,
    is_embossed: newLayer.is_embossed,
    is_foldable: newLayer.is_foldable,
    is_monogram: newLayer.is_monogram,
    is_raised: newLayer.is_raised,
    is_repousse: newLayer.is_repousse,
    is_shadow_cut: newLayer.is_shadow_cut,
    is_stencil: newLayer.is_stencil,
    is_two_sided: newLayer.is_two_sided,

    layer_mask: newLayer.layer_mask,
    left_position: newLayer.left_position,
    layer_name: newLayer.layer_name,
    photo_image: newLayer.photo_image,

    print_color_setting_name: newLayer.print_color_setting_name,
    print_color_type: newLayer.print_color_type,
    print_colors: newLayer.print_colors || [],
    print_color: newLayer.print_color,
    print_color_from_layer:
      newLayer.print_color_from_layer === undefined
        ? ""
        : newLayer.print_color_from_layer,
    product_mask: newLayer.product_mask,
    text_collection_name: newLayer.text_collection_name,
    text_collection_max_length: newLayer.text_collection_max_length,
    top_position: newLayer.top_position,
    use_color_mask: newLayer.use_color_mask,
    use_product_mask: newLayer.use_product_mask,
    width: newLayer.width,
  };

  return layer;
}

function copyFromOption(state, newOption) {
  const newState = {
    ...state,
    original_option_id: newOption.id,
    color_setting_type:
      newOption.color_setting_type || state.color_setting_type,
    default_image_size:
      newOption.default_image_size || state.default_image_size,
    disable_print_plate_check:
      newOption.disable_print_plate_check || state.disable_print_plate_check,
    display_dimentions:
      newOption.display_dimentions || state.display_dimentions,
    font_sizes: newOption.font_sizes || state.font_sizes,
    image_sizes: newOption.image_sizes || state.image_sizes,
    is_two_sided: newOption.is_two_sided || state.is_two_sided,
    max_printable_area:
      newOption.max_printable_area || state.max_printable_area,
    max_printable_area_height:
      newOption.max_printable_area_height || state.max_printable_area_height,
    max_printable_area_width:
      newOption.max_printable_area_width || state.max_printable_area_width,
    name: newOption.name || state.name,
    preview_height: newOption.preview_height || state.preview_height,
    preview_width: newOption.preview_width || state.preview_width,
    preview_product_width_px:
      newOption.preview_product_width_px || state.preview_product_width_px,
    preview_image_width_px:
      newOption.preview_image_width_px || state.preview_image_width_px,
    print_options: newOption.print_options || state.print_options,
    printable_area_height_in:
      newOption.printable_area_height_in || state.printable_area_height_in,
    printable_area_width_in:
      newOption.printable_area_width_in || state.printable_area_width_in,
    product_height_inches:
      newOption.product_height_inches || state.product_height_inches,
    product_width_inches:
      newOption.product_width_inches || state.product_width_inches,
  };

  const iteratorLength =
    newOption.layer_set.length > newState.layer_set.length
      ? newOption.layer_set.length
      : newState.layer_set.length;

  //TODO: This needs to be re-written to be more clear. Also why can't we just set the newState to the newOptions?
  //Why merge everything just to get the same results as newOption
  //newOption.layer_set means the new options
  //newState.layer_set means old options, but will be turned into
  let buildingLayerState = [];
  for (var i = 0; i < iteratorLength; i++) {
    let newLayer = newOption.layer_set[i];

    //If already iterated over every new layer then stop (If the new layerset is smaller)
    if (!newLayer) {
    } else if (newState.layer_set.length <= i) {
      //adds a new layer if there are more newOptions than old (If the new layerset is bigger)
      let layer = newOption.layer_set[i];
      delete layer.id; /** delete layer id so that when overwriting a design, we don't link back to the old option's layer **/

      const combineLayers = newState.layer_set.concat(layer);
      newState.layer_set = combineLayers;
      buildingLayerState.push(
        ensureLayerHasDefaultColor(layer, state.layer_set[i]),
      );
    } else {
      //If there is an old layer and a new layer, take the old layer as a default and override everything else with the new layer
      let layer = mergeLayers(state.layer_set[i], newLayer);
      buildingLayerState.push(
        ensureLayerHasDefaultColor(layer, state.layer_set[i]),
      );
    }
  }
  newState.layer_set = buildingLayerState;

  newState.preview_scale = calculatePreviewScale(newState);

  return newState;
}

function copyPrintOptionToDesign(state) {
  let print_option = state.print_options[state.selected_print_option];

  if (
    print_option &&
    print_option.layer_set &&
    print_option.layer_set.length > 0
  ) {
    print_option.layer_set.forEach((newLayer) => {
      state.layer_set.forEach((currentLayer, index) => {
        if (currentLayer.layer_id !== newLayer.layer_id) {
          return;
        }

        state.layer_set[index] = {
          ...currentLayer,
          allow_image: newLayer.allow_image,
          allow_text: newLayer.allow_text,
          font_sizes: newLayer.font_sizes.length
            ? newLayer.font_sizes
            : currentLayer.font_sizes,
          has_print_color: newLayer.has_print_color,
          is_embossed: newLayer.is_embossed,
          is_repousse: newLayer.is_repousse,
          photo_image: newLayer.photo_image,
          print_color_setting_name: newLayer.print_color_setting_name.length
            ? newLayer.print_color_setting_name
            : currentLayer.print_color_setting_name,
          print_color_type: newLayer.print_color_type,
        };
      });
    });
  }

  return state;
}

export default function (state = initialState, action) {
  switch (action.type) {
    case DESIGN.SUCCESS:
      // setup the first
      let variationDesign = action.response.design;
      variationDesign.original_option_id = action.response.product_option.id;
      variationDesign.layer_set = variationDesign.layer_set.map((layer) => {
        return ensureLayerHasDefaultColor(layer);
      });
      variationDesign.preview_scale = calculatePreviewScale(
        action.response.product_option,
      );
      return variationDesign;

    case SET_ORIGINAL_DESIGN_ID:
      return state.id != action.payload.original_design_id
        ? {
          ...state,
          original_design_id: action.payload.original_design_id,
        }
        : {...state};

    case UPDATE_DESIGN_NAME:
      return {
        ...state,
        name: action.payload,
      };

    case UPDATE_OPTION:
      let newState = copyFromOption(state, action.payload.option);
      newState.product_option_id = action.payload.option.id;
      newState.selected_print_option = action.payload.selectedPrintOption;
      newState.product_variant_id = action.payload.option.product_variant_id;
      newState = copyPrintOptionToDesign(newState);

      return newState;

    case SELECT_PRINT_OPTION:
      let textElementsArray = [],
        textElementsIndex = 0,
        imageElementsArray = [],
        imageElementsIndex = 0,
        photoImageElementsArray = [],
        photoImageElementsIndex = 0;

      state.layer_set.forEach((layer) => {
        if (layer.text_elements.length) {
          textElementsArray.push(layer.text_elements);
        }
        if (layer.image_elements.length) {
          const photos = layer.image_elements.filter(
            (image) => image.type === "photo",
          );
          photos.forEach((image) => {
            photoImageElementsArray.push(image);
          });
          const artAndClipart = layer.image_elements.filter(
            (image) => image.type !== "photo",
          );
          artAndClipart.forEach((image) => {
            imageElementsArray.push(image);
          });
        }
      });

      let newPrintState = copyFromOption(state, action.payload.option);

      let firstPrintOption = null;
      //this currently finds the LAST available print option for the option.
      //TODO make it choose the first instead
      newPrintState.print_options.forEach((printOption, index) => {
        printOption.filters.forEach((filter) => {
          if (
            filter.type_name === action.payload.filterName &&
            filter.value === action.payload.printOptionFilter &&
            firstPrintOption === null
          ) {
            firstPrintOption = index;
          }
        });
      });

      newPrintState.product_option_id = action.payload.option.id;
      newPrintState.selected_print_option = firstPrintOption;
      newPrintState.product_variant_id =
        action.payload.option.product_variant_id;
      newPrintState = copyPrintOptionToDesign(newPrintState);

      newPrintState.layer_set.forEach((layer, index) => {
        let newTextElements = [],
          newImageElements = [];

        if (layer.allow_text) {
          textElementsIndex++;
          newTextElements =
            textElementsArray.length >= textElementsIndex
              ? textElementsArray[textElementsIndex - 1]
              : [];
        }

        if (layer.allow_image) {
          imageElementsIndex++;
          if (imageElementsArray.length >= imageElementsIndex) {
            newImageElements.push(imageElementsArray[imageElementsIndex - 1]);
          }
        }

        if (layer.photo_image) {
          photoImageElementsIndex++;
          if (photoImageElementsArray.length >= photoImageElementsIndex) {
            newImageElements.push(
              photoImageElementsArray[photoImageElementsIndex - 1],
            );
          }
        }

        newPrintState.layer_set[index] = {
          ...layer,
          text_elements: newTextElements,
          image_elements: newImageElements,
        };
      });

      return newPrintState;

    case OVERRIDES_APPLIED:
      return {
        ...state,
      };

    case UPDATE_COLOR:
      let newColorState = { ...state };
      newColorState.layer_set = newColorState.layer_set.map((layer) => {
        let newLayer = { ...layer };
        if (newLayer.layer_id === action.payload.layerId) {
          if (action.payload.type === "Paper") {
            newLayer.color = { ...action.payload.color };
          } else {
            newLayer.print_color = { ...action.payload.color };
          }
        }
        return newLayer;
      });
      return newColorState;

    case PRODUCTVARIANTCOLORS.SUCCESS:
      let colorsState = { ...state };
      colorsState.layer_set = colorsState.layer_set.map((layer) => {
        let newLayer = { ...layer };
        if (newLayer.layer_id === action.response.layer_id) {
          if (action.response.type === "Print") {
            newLayer.print_colors = [...action.response.colors];
          } else {
            newLayer.colors = [...action.response.colors];
          }
        }
        return ensureLayerHasDefaultColor(newLayer, layer);
      });
      return colorsState;

    case SAVE_DESIGN.REQUEST:
      return {
        ...state,
        isSaving: true,
      };

    case SAVE_DESIGN.SUCCESS:
      return {
        ...state,
        id: action.response.id,
        isSaving: false,
      };

    case SAVE_DESIGN.FAILURE:
      return {
        ...state,
        isSaving: false,
      };

    case DISPLAY_LOGIN_PROMPT:
      return {
        ...state,
        displayLoginPrompt: action.payload,
      };

    case ADD_DESIGN_TO_CART.REQUEST:
      return {
        ...state,
        isRedirecting: true,
      };

    case PRODUCTVARIANT.SUCCESS:
      return {
        ...state,
        product_info: action.response.product_info,
        pricing: action.response.pricing,
      };

    default:
      return state;
  }
}
